import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { Icon, Spin, ToolbarButton } from "./index.js";
/**
 * Renders the toolbar with button. If <code>props.activeButton</code> is
 * set all other <code>ToolbarButton</code>`s are disabled expect the <code>props.backButton</code> -
 * then the user clicks on the cancel button (<code>props.backButton.label</code>)
 * and the <code>onCancel</code> callback of the ToolbarButton gets executed.
 *
 * <p>If the ToolbarButton has a valid <code>onSave</code> callback the toolbar has an additional save button (<code>props.backButton.save</code>)
 * - then the user clicks on the save button and the callback gets executed.</p>
 *
 * @returns
 */ export class Toolbar extends Component {
    render() {
        const { isToolbarActive, isToolbarBusy, buttons, backButton, activeButton, checkedNodes, onCloseMultiToolbar } = this.props;
        const activeActions = [];
        const hasActionButtonSave = activeButton && buttons[activeButton].onSave;
        activeButton && activeActions.push(/*#__PURE__*/ _jsx(ToolbarButton, {
            content: backButton.label,
            onClick: this.handleCancelClick
        }, "activeButtonCancel"));
        hasActionButtonSave && activeActions.push(/*#__PURE__*/ _jsx(ToolbarButton, {
            content: backButton.save,
            onClick: hasActionButtonSave
        }, "activeButtonSave"));
        return(// @ts-expect-error outdated @types/react
        /*#__PURE__*/ _jsx(Spin, {
            spinning: isToolbarBusy,
            size: "small",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "aiot-toolbar",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "aiot-toolbar-items",
                        children: [
                            activeButton ? activeActions : Object.keys(buttons).map((key)=>{
                                return /*#__PURE__*/ _jsx(ToolbarButton, {
                                    ...buttons[key],
                                    disabled: !isToolbarActive ? true : buttons[key].disabled
                                }, key);
                            }),
                            checkedNodes.length > 0 && [
                                /*#__PURE__*/ _jsx(ToolbarButton, {
                                    cssClasses: "aiot-border-left",
                                    disabled: true,
                                    content: /*#__PURE__*/ _jsxs("span", {
                                        children: [
                                            /*#__PURE__*/ _jsx(Icon, {
                                                type: "check"
                                            }),
                                            " ",
                                            checkedNodes.length
                                        ]
                                    })
                                }, "multiple-count"),
                                /*#__PURE__*/ _jsx(ToolbarButton, {
                                    content: /*#__PURE__*/ _jsx(Icon, {
                                        type: "close"
                                    }),
                                    onClick: onCloseMultiToolbar
                                }, "multiple-close")
                            ]
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "clear"
                    })
                ]
            })
        }));
    }
    constructor(...args){
        super(...args);
        this.handleCancelClick = (cancelNode)=>{
            const originalNode = this.props.buttons[this.props.activeButton];
            originalNode && originalNode.onCancel && originalNode.onCancel(cancelNode, originalNode);
        };
    }
}
